<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense nav>
        <v-list-item link @click="navTokenList">
          <v-list-item-icon>
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Token Marketplace</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!--v-list-item link @click="navAbout">
          <v-list-item-icon>
            <v-icon>mdi-information</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>About</v-list-item-title>
          </v-list-item-content>
        </v-list-item-->
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="dark" height="100">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <!--v-toolbar-title>RedFeg Tracker</v-toolbar-title-->
      <v-toolbar-title>
        <v-img
          contain
          src="./assets/RedFEG-Tracker.png"
          max-height="100"
        ></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog
        v-model="settingsDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="dark" dark v-bind="attrs" v-on="on">
            <v-icon>mdi-account-settings</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-toolbar dark color="dark">
            <v-btn icon dark @click="settingsDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Settings</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="saveSettings"> Save </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader>
            <v-subheader>General</v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Wallet</v-list-item-title>
                <v-text-field
                  label="Wallet Address"
                  v-model="settingsForm.walletAddress"
                  :rules="ethereumAddressRules"
                  hide-details="auto"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-dialog>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-footer app color="red">
      <app-footer></app-footer>
    </v-footer>
  </v-app>
</template>

<script>
import AppFooter from "./components/Footer";
import { mapState } from "vuex";
import { getStorageConfig, updateStorageConfig } from "./store/storage";

export default {
  name: "App",

  components: {
    AppFooter,
  },

  data: () => ({
    drawer: false,
    settingsDialog: false,
    settingsForm: {
      walletAddress: null,
    },
    storageConfig: null,
    ethereumAddressRules: [
      (v) => !!v || "Ethereum address is required",
      (v) =>
        /^(0x)?[0-9a-fA-F]{40}$/.test(v) || "Ethereum address must be valid",
    ],
  }),

  mounted() {
    this.storageConfig = getStorageConfig();
    this.settingsForm.walletAddress = this.storageConfig.walletAddress;
  },

  methods: {
    saveSettings() {
      this.settingsDialog = false;
      this.storageConfig.walletAddress = this.settingsForm.walletAddress;
      updateStorageConfig(this.storageConfig);
    },
    navTokenList() {
      this.$router.push("/tokens");
    },
    navAbout() {
      this.$router.push("/about");
    },
  },
  computed: {
    ...mapState([]),
  },
};
</script>
